jQuery(document).ready(function(){

    jQuery('.navbar-toggler').on('click',function(){
        console.log(jQuery(this));
        if (jQuery(this).attr("aria-expanded") === "true") {
            jQuery('body').addClass('mobile-menu-open');
        } else {
           jQuery('body').removeClass('mobile-menu-open');
        }
    })

    jQuery(".nav-link.dropdown-toggle").removeAttr("data-bs-toggle");

})  
